import {
  PiCalendar,
  PiCalendarFill,
  PiChartBar,
  PiChartBarFill,
  PiCoins,
  PiCoinsFill,
  PiFaders,
  PiFadersFill,
  PiFolder,
  PiFolderFill,
  PiHeadphones,
  PiHeadphonesFill,
  PiHeadset,
  PiHeadsetFill,
  PiHouseLine,
  PiHouseLineFill,
  PiIdentificationCard,
  PiIdentificationCardFill,
  PiMicrophoneStage,
  PiMicrophoneStageFill,
  PiPresentationChart,
  PiPresentationChartFill,
  PiReceipt,
  PiReceiptFill,
  PiScroll,
  PiScrollFill,
  PiShield,
  PiShieldFill,
  PiSquaresFour,
  PiSquaresFourFill,
  PiStack,
  PiStackFill,
  PiStorefront,
  PiStorefrontFill,
  PiUserCircle,
  PiUserCircleFill,
  PiVideo,
  PiVideoFill,
  PiWallet,
  PiWalletFill,
  PiWaveform,
} from 'react-icons/pi';
import { isDevelopment } from 'services/environment/Environment';
import { INavbarItem } from 'types/navbar/navbar.interface';

export const navbarItems: INavbarItem[] = [
  {
    path: '',
    name: 'home',
    icon: PiHouseLine,
    fillIcon: PiHouseLineFill,
    children: [
      {
        path: 'dashboard',
        icon: PiSquaresFour,
        fillIcon: PiSquaresFourFill,
      },
      // ...(isDevelopment
      //   ? [
      //       {
      //         path: 'statistics',
      //         icon: PiChartBar,
      //         fillIcon: PiChartBarFill,
      //       },
      //     ]
      //   : []),
      // {
      //   path: 'calendar',
      //   icon: PiCalendar,
      //   fillIcon: PiCalendarFill,
      // },
    ],
  },
  {
    path: 'content',
    icon: PiFolder,
    fillIcon: PiFolderFill,
    children: [
      {
        path: 'artist',
        icon: PiMicrophoneStage,
        fillIcon: PiMicrophoneStageFill,
      },
      {
        path: 'track',
        icon: PiWaveform,
        fillIcon: PiWaveform,
      },
      // {
      //   path: 'video',
      //   icon: PiVideo,
      //   fillIcon: PiVideoFill,
      // },
    ],
  },
  {
    path: 'products',
    icon: PiStorefront,
    fillIcon: PiStorefrontFill,
    children: [
      {
        path: 'music-product-digital',
        icon: PiHeadphones,
        fillIcon: PiHeadphonesFill,
      },
      // {
      //   path: 'music-product-physical',
      //   icon: PiCassetteTape,
      //   fillIcon: PiCassetteTapeFill,
      // },
      {
        path: 'channel',
        icon: PiVideo,
        fillIcon: PiVideoFill,
      },
      // ...(isDevelopment
      //   ? [
      //       {
      //         path: 'merch',
      //         icon: PiShoppingBag,
      //         fillIcon: PiShoppingBagFill,
      //       },
      //     ]
      //   : []),
    ],
  },
  {
    path: 'finances',
    icon: PiPresentationChart,
    fillIcon: PiPresentationChartFill,
    children: [
      {
        path: 'settlement',
        icon: PiCoins,
        fillIcon: PiCoinsFill,
      },
      {
        path: 'label-report',
        icon: PiCoins,
        fillIcon: PiCoinsFill,
      },
      {
        path: 'balance',
        icon: PiReceipt,
        fillIcon: PiReceiptFill,
      },
      {
        path: 'advance',
        icon: PiWallet,
        fillIcon: PiWalletFill,
      },
      { path: 'contracts', icon: PiScroll, fillIcon: PiScrollFill },
    ],
  },
  {
    path: 'settings',
    icon: PiPresentationChart,
    hidden: true,
    children: [
      {
        path: 'label',
        icon: PiUserCircle,
        fillIcon: PiUserCircleFill,
      },
      {
        path: 'certificates',
        icon: PiIdentificationCard,
        fillIcon: PiIdentificationCardFill,
      },
      {
        path: 'preferences',
        icon: PiFaders,
        fillIcon: PiFadersFill,
      },
      {
        path: 'security',
        icon: PiShield,
        fillIcon: PiShieldFill,
      },

      {
        path: 'support',
        icon: PiHeadset,
        fillIcon: PiHeadsetFill,
      },
    ],
  },
];
